// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G_ox9","label":"styles_label__2SUan"};